module.exports = __webpack_public_path__ + "img/img-tcf-md@2x.276d54df.jpg";